var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, styled, Typography, Box } from "@mui/material";
import { useDrag } from "react-dnd";
import { ItemTypes } from "../dnd/ItemTypes";
import { TeamColorsCircle } from "../teams/TeamColors";
var StyledDraggableItem = styled(Paper)(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({ backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff" }, theme.typography.body2), { padding: theme.spacing(1), width: "100%", color: theme.palette.text.secondary, border: "1px dashed gray", cursor: "grab", userSelect: "none", boxSizing: "border-box", "&:hover": {
            backgroundColor: theme.palette.action.hover,
        } }));
});
export var TeamDragger = function (_a) {
    var team = _a.team, onDrop = _a.onDrop;
    var _b = __read(useDrag(function () { return ({
        type: ItemTypes.TEAM,
        item: { team: team },
        end: function (item, monitor) {
            onDrop(item.team, monitor);
        },
        collect: function (monitor) { return ({
            opacity: monitor.isDragging() ? 0.4 : 1,
        }); },
    }); }, [team, onDrop]), 2), opacity = _b[0].opacity, drag = _b[1];
    return (_jsx(StyledDraggableItem, { ref: drag, style: { opacity: opacity }, children: _jsxs(Box, { sx: {
                display: "flex",
                alignItems: "center",
                gap: 1,
                textAlign: "left",
            }, children: [_jsx(Box, { sx: {
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        overflow: "hidden",
                        flexShrink: 0,
                    }, children: _jsx(TeamColorsCircle, { color1: team.primaryColour || "grey.500", color2: team.secondaryColour || "grey.300" }) }), _jsxs(Box, { sx: { minWidth: 0, flex: 1 }, children: [_jsx(Typography, { variant: "body2", fontWeight: "medium", noWrap: true, children: team.name }), team.nickname && (_jsx(Typography, { variant: "caption", color: "text.secondary", fontStyle: "italic", noWrap: true, children: team.nickname }))] })] }) }));
};
